import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import { useUser } from "@descope/react-sdk";
import { GetDraftById } from "src/redux/features/mailBox/mailbox-slice";
import EmailEditor from "./EmailEditor";
import { Box, CircularProgress } from "@mui/material";

const EditDraftEmail: React.FC = () => {
  const { id } = useParams();
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const { currentDraft, isLoading } = useAppSelector(
    (state) => state.mailBoxSlice
  );
  useEffect(() => {
    if (user?.email && id) {
      dispatch(
        GetDraftById({
          userEmail: user.email,
          draftId: id,
        })
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, user]);

  return (
    <div>
      {isLoading ? (
        <Box className="customLoader">
          <CircularProgress />
        </Box>
      ) : (
        <EmailEditor isDraft={true} currentDraft={currentDraft} isDialogView={false}/>
      )}
    </div>
  );
};

export default EditDraftEmail;
